import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-loading-spinner-overlay',
  templateUrl: './loading-spinner-overlay.component.html',
  styleUrls: ['./loading-spinner-overlay.component.scss'],
  standalone: true,
  imports: [LoadingSpinnerComponent],
})
export class LoadingSpinnerOverlayComponent implements OnInit {
  @Input() loadingHintTranslationKey!: string;
  @Input() fullPage = true;
  constructor() {}

  @HostBinding('class.widget-spinner')
  get isWidget() {
    return !this.fullPage;
  }

  ngOnInit(): void {}
}
